import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {hideLoader, showLoader} from 'core/actions/app'

const LazyFallback = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(showLoader())

    return () => dispatch(hideLoader())
  }, [])

  return <></>
}

export default LazyFallback
